import { render, staticRenderFns } from "./DialogoBuscarProdutoGrupos.vue?vue&type=template&id=80d21780&scoped=true&"
import script from "./DialogoBuscarProdutoGrupos.vue?vue&type=script&lang=js&"
export * from "./DialogoBuscarProdutoGrupos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d21780",
  null
  
)

export default component.exports